import Vue from 'vue'

var moment = require('moment');
window.moment = moment

moment.locale("es");

Vue.use(require('vue-moment'), {
    moment,
})